<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const title = field<string>("title", "Accordion Item");
const number = field<string>("number", "1");
const icon = field<string>("icon", "");
const expandAlignment = field<string>("expandAlignment", "right");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:chevrons-up-down" accent="container">
    <EditorField :label="t('titleLabel')">
      <Input v-model="title" class="h-8 rounded-sm bg-muted text-[13px]" :placeholder="t('titlePlaceholder')" />
    </EditorField>

    <EditorField :label="t('numberLabel')">
      <Input v-model="number" class="h-8 rounded-sm bg-muted text-[13px]" :placeholder="t('numberPlaceholder')" />
    </EditorField>

    <EditorField :label="t('iconLabel')" :hint="t('iconHint')">
      <Input v-model="icon" class="h-8 rounded-sm bg-muted text-[13px]" :placeholder="t('iconPlaceholder')" />
    </EditorField>

    <EditorField :label="t('expandAlignmentLabel')">
      <Select :model-value="expandAlignment" @update:model-value="(value) => (expandAlignment = value as string)">
        <SelectTrigger class="h-8 rounded-sm bg-muted text-[13px]">
          <SelectValue :placeholder="t('expandAlignmentPlaceholder')" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="left">{{ t("left") }}</SelectItem>
          <SelectItem value="right">{{ t("right") }}</SelectItem>
        </SelectContent>
      </Select>
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Accordion Item"
  titleLabel: "Title"
  titlePlaceholder: "Accordion item title"
  numberLabel: "Number"
  numberPlaceholder: "Enter a number"
  iconLabel: "Icon"
  iconHint: "Use an Iconify name such as lucide:chevrons-up-down."
  iconPlaceholder: "lucide:chevrons-up-down"
  expandAlignmentLabel: "Expand Alignment"
  expandAlignmentPlaceholder: "Select alignment"
  left: "Left"
  right: "Right"
</i18n>
